import React from "react";
import { CourseValidationError, SimulationAttempt, SimulationSession, SimulationTranscripts } from "src/types/coaching/courses";
import { LearningRecordSimulation } from "src/types/coaching/learners";

export interface SelectedItem {
  id: string;
  type: "lesson" | "podcast" | "simulation";
  title?: string;
}

export interface CallRecordingState {
  attempt: SimulationAttempt;
  session?: SimulationSession;
  loading: boolean;
  transcripts?: SimulationTranscripts[];
}

export interface SimulationReportState {
  attempt: SimulationAttempt;
  session: SimulationSession;
}

export interface CourseContextProps {
  id?: string;
  courseContent?: any;
  preferences?: any;
  validationError?: CourseValidationError;
  
  showValidationErrorDialog?: boolean;
  
  // eslint-disable-next-line no-unused-vars
  setShowValidationErrorDialog?: (show: boolean) => void;

  // eslint-disable-next-line no-unused-vars
  gotoError(error?: CourseValidationError): void;
  
  // eslint-disable-next-line no-unused-vars
  updatePreferences?: (preferences: any) => void;
  selected?: any;
  setSelected?: any;
  selectedSectionId?: string | null;
  setSelectedSectionId?: (id: string | null) => void;
  onContentTypeSelect?: (parentSectionId?: string | null) => void;
  showAssetsDialog: boolean;
  setShowAssetDialog: React.Dispatch<React.SetStateAction<boolean>>;
  callRecording?: CallRecordingState | null;
  openCallRecording?: (data: { attempt: SimulationAttempt; session?: SimulationSession }) => void;
  closeCallRecording?: () => void;
  simulationReport?: SimulationReportState | null;
  openSimulationReport?: (data: {attempt: SimulationAttempt; session: SimulationSession}) => void;
  closeSimulationReport?: () => void;
  simulationLearningRecord?: LearningRecordSimulation;
}

export const CourseContext = React.createContext<CourseContextProps>({
  gotoError: () => {},
  selected: [],
  setSelected: () => {},
  showAssetsDialog: false,
  setShowAssetDialog: () => {},
  simulationReport: null,
});
